<template>
    <section class="premium-carousel">
        <div v-if="data && data.product_images.length" class="carousel-container">
            <div id="premiumCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="5000" data-bs-touch="true">
                <!-- <div class="carousel-indicators">
                    <button v-for="(item, index) in data.product_images" :key="index" type="button" data-bs-target="#premiumCarousel" :data-bs-slide-to="index" :class="item_index == item.id ? 'active' : ''" :aria-current="item_index == item.id ? 'true' : ''"></button>
                </div> -->

                <div class="carousel-inner">
                    <div v-for="(item, index1) in data.product_images" :key="index1" class="carousel-item" :class="item_index == item.id ? 'active' : ''">
                        <img :src="item.image" class="carousel-image" :alt="item.name">
                        <div class="carousel-overlay">
                            <div class="carousel-content fs-6">
                                <h2 class="carousel-title font-display text-white mb-3">
                                    {{ data.translate.length ? data.translate[0].name : '' }}
                                </h2>
                                <div class="carousel-description text-white" v-html="data.translate.length ? data.translate[0].description : ''"></div>
                                <div class="carousel-price text-black bg-light bg-opacity-50 rounded">
                                    {{ TR.price }} {{ G.formatLocale(data.per_qiymet_rayon * perc) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button v-if="data && data.product_images.length > 1" class="carousel-control-prev" type="button" data-bs-target="#premiumCarousel" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button v-if="data && data.product_images.length > 1" class="carousel-control-next" type="button" data-bs-target="#premiumCarousel" data-bs-slide="next">
                    <span class="carousel-control-next-icon"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
        <div v-else>
            <div class="carousel-overlay rounded">
                    <div class="carousel-content">
                        <h2 class="carousel-title font-display text-white mb-3">
                            {{ data.translate.length ? data.translate[0].name : '' }}
                        </h2>
                        <div class="carousel-description text-white" v-html="data.translate.length ? data.translate[0].description : ''"></div>
                        <div class="carousel-price text-black bg-light bg-opacity-25 rounded">
                            {{ TR.price }} {{ G.formatLocale(data.per_qiymet_rayon * perc) }}
                        </div>
                    </div>
                </div>
        </div>
    </section>
</template>

<script>
import { ref, watchEffect } from 'vue';
import { useStore } from '@/system_modules/store';

import { G } from '@/_common';

export default {
    name: 'CarouselC',
    props: ['data', 'item_index'],
    setup() {
        const store = useStore();

        const TR = ref();
        const perc = 1;

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        return {
            G,
            TR,
            perc,
        };
    },
}
</script>


<style lang="scss">

:root{
    --carousel-height: calc(100vh - 280px);
}
.premium-carousel {
    position: relative;
    margin: .4rem 0;
    height: var(--carousel-height) !important;

.carousel{
    height: var(--carousel-height) !important;
}
.carousel-container {
    position: relative;
    border-radius: 20px !important;
    overflow: hidden;
    box-shadow:
        0 20px 50px rgba(0, 0, 0, 0.3),
        0 0 0 1px rgba(255, 255, 255, 0.1);
}

.carousel-item {
    // height: 75vh;
    height: var(--carousel-height) !important;
    // min-height: 600px;
    position: relative;
    overflow: hidden;
}

.carousel-image {
    // width: 100%;
    display: block;
    height: 100%;
    margin: 0 auto;
    // text-align: center;
    // object-fit: cover;
    /* transition: transform 8s ease-out; */
    transition: all 5s cubic-bezier(0.23, 1, 0.32, 1);
}

.carousel-item.active .carousel-image {
    transform: scale(1.05);
}

/* Premium Overlay */
.carousel-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--background-gradient) !important;
    display: flex;
    align-items: end !important;
    justify-content: center;
    transition: all 0.6s ease;
}

.carousel-content {
    position: relative;
    text-align: center;
    width: 800px;
    max-width: 800px;
    // margin-bottom: 60px;
    padding: 2rem !important;
    z-index: 10;
    background: var(--background-gradient);
    // border: 1px solid red;
    border-radius: 20px;
}

.carousel-title {
    font-size: clamp(1.5rem, 1vw, 1rem) !important;
    font-weight: 800;
    line-height: 1.1;
    // margin-bottom: 1.5rem;
    text-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
}

.carousel-description {
    font-size: clamp(1.1rem, 1vw, 1.5rem) !important;
    font-weight: 300;
    line-height: 1.1;
    word-break: break-all;
    // opacity: 0.9;
    // margin-bottom: 3rem;
}

.carousel-price {
    font-size: clamp(1.2rem, 1vw, 1rem) !important;
    font-weight: 700;
    // color: var(--accent-gold);
    text-shadow: 0 2px 10px rgba(212, 175, 55, 0.3);
    // margin-bottom: 2rem;
}

/* Premium Controls */
.carousel-control-prev,
.carousel-control-next {
    width: 80px;
    height: 80px;
    background: rgba(236, 5, 5, 0.2) !important;
    backdrop-filter: blur(20px);
    border: 1px solid rgba(236, 5, 5, 0.2) !important;
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    opacity: 1;
}

.carousel-control-prev {
    left: 2rem;
}

.carousel-control-next {
    right: 2rem;
}

.carousel-control-prev:hover,
.carousel-control-next:hover {
    background: rgba(236, 5, 5, 0.5);
    border-color: var(--primary-color);
    opacity: 1;
    transform: translateY(-50%) scale(1.1);
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
    width: 24px;
    height: 24px;
    background-size: 24px 24px;
    filter: brightness(0) invert(1);
}

/* Custom Indicators */
.carousel-indicators {
    bottom: 2rem;
    margin-bottom: 0;
}

.carousel-indicators [data-bs-target] {
    width: 60px;
    height: 24px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.3);
    border: none;
    margin: 0 5px;
    transition: all 0.4s ease;
}

.carousel-indicators .active {
    background: var(--primary-color);
    box-shadow: 0 0 20px var(--primary-glow);
}
@media (max-width: 768px) {
    :root{
        --carousel-height: calc(100vh - 260px);
    }
    .carousel-image{
        width: 100%;
        height: unset;
    }
    .carousel-control-prev,
    .carousel-control-next {
        width: 60px;
        height: 60px;
    }

    .carousel-control-prev {
        left: 1rem;
    }

    .carousel-control-next {
        right: 1rem;
    }

    .carousel-content {
        padding: 1rem;
    }

    .btn-premium,
    .btn-outline-premium {
        padding: 0.8rem 2rem;
        font-size: 1rem;
    }
}
}
</style>